module.exports = __webpack_public_path__ + "img/OGG_Background_White.fe949fb2.png";